import * as React from 'react';
import { Responsive } from '@cian/ui-kit';
import * as styles from './Categories.css';
import { CategoryItem } from './components/CategoryItem';
import { ICategory } from '../../types/promosPage';
import { Section } from '../Section';

interface ICategoriesProps {
  categories: ICategory[];
  onCategoryClick?(category?: ICategory): void;
}

export const Categories: React.FC<ICategoriesProps> = ({ categories, onCategoryClick }) => {
  const desktopColumns = React.useMemo(() => {
    const middle = Math.ceil(categories.length / 2);

    return [categories.slice(0, middle), categories.slice(middle)].filter(col => col.length);
  }, [categories]);

  return (
    <Section title="Все категории" data-testid="CategoriesSection">
      <Responsive phone tablet>
        <div>
          {categories.map(category => {
            return <CategoryItem category={category} onClick={onCategoryClick} key={category.name} />;
          })}
        </div>
      </Responsive>
      <Responsive desktop>
        <div className={styles['categories-row--desktop']}>
          {desktopColumns.map((column, idx) => (
            <div className={styles['categories-col--desktop']} key={idx}>
              {column.map(category => {
                return <CategoryItem category={category} onClick={onCategoryClick} key={category.name} />;
              })}
            </div>
          ))}
        </div>
      </Responsive>
    </Section>
  );
};
